import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { defineStyles } from '../../theme';
import { useSTColumns } from '../../table/SmartTableContext';
const styles = defineStyles({
    addColumnActions: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        columnGap: 2,
        mt: 2,
    },
    actionsButtons: {
        display: 'flex',
        columnGap: 1,
        ml: 'auto',
    },
    addedInput: {
        flexGrow: 1,
    },
});
const NewFieldInput = ({ onAddField, onCancel }) => {
    const intl = useIntl();
    const { allColumns } = useSTColumns();
    const [addFieldValue, setAddFieldValue] = useState('');
    const isValid = /^[a-zA-Z0-9_]+$/.test(addFieldValue) && allColumns.every((i) => i.fieldName !== addFieldValue);
    const isError = !isValid && addFieldValue !== '';
    const handleAddField = () => {
        if (!isValid)
            return;
        setAddFieldValue('');
        onAddField(addFieldValue);
    };
    const handleEnterPress = (e) => {
        if (e.key !== 'Enter')
            return;
        e.preventDefault();
        handleAddField();
    };
    return (_jsxs(Box, { sx: styles.addColumnActions, children: [_jsx(TextField, { autoFocus: true, sx: styles.addedInput, variant: "standard", value: addFieldValue, onChange: (e) => setAddFieldValue(e.target.value.trim()), placeholder: intl.formatMessage({
                    id: 'batchEdit.addColumn.input.placeholder',
                    defaultMessage: 'Enter column name',
                }), error: isError, onKeyDown: (e) => handleEnterPress(e), helperText: isError && (_jsx(FormattedMessage, { id: "batchEdit.addColumn.input.errorMessage", defaultMessage: "Illegal characters for column name" })) }), _jsxs(Box, { sx: styles.actionsButtons, children: [_jsx(Button, { disabled: !isValid, variant: "contained", type: "button", onClick: handleAddField, children: _jsx(FormattedMessage, { id: "common.add.button", defaultMessage: "Add" }) }), _jsx(Button, { variant: "outlined", type: "button", onClick: onCancel, children: _jsx(FormattedMessage, { id: "common.cancel.button", defaultMessage: "Cancel" }) })] })] }));
};
export default NewFieldInput;
//# sourceMappingURL=NewFieldInput.js.map